module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="zmags-section wide">\n    <div class="matomo-region"></div>\n</section>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/reporting/MatomoReportingView.tpl
// module id = 2898
// module chunks = 0